/* eslint-disable react/no-danger */
import React from 'react'
import TabComponent from '@components/NTabs/NTabs'
import { getGroupedSectionCardsMap } from '@components/NColumnGrid/utils'
import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import { convertToSlug } from 'src/utils/IdGenerator'
import { getHeadingDesc } from '@utils/schemaUtils'
import { HTMLTagsForHowTo } from '@configs/howToHTMLTag'
import styles from './accordion.module.scss'
import AccordionItem from './AccordionItem'
import ImageComponent from './ImageComponent'
import { evaluateAccordionType } from './accordianData'

const Accordion = ({ data }) => {
  const type = evaluateAccordionType(data).inputType
  const withImage = evaluateAccordionType(data).withImage || false
  const accordianData = data?.data?.attributes
  const hasTabs = data?.data?.attributes?.hasTabs || false

  const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

  const accordionOuterClass = !withImage ? `${styles.fullWidthRootContainer}` : `${styles.halfWidthRootContainer}`

  const accordionContainerClass = !withImage ? `${styles.fullWidthContainer}` : `${styles.halfWidthContainer}`

  const mappedValuesForTabs = getGroupedSectionCardsMap(accordianData?.accordionCards)

  // Extract the h2 content and headerTabName
  const h2Regex = /<h2[^>]*>(.*?)<\/h2>/
  const matches = accordianData?.sectionHeading.match(h2Regex)
  const h2Content = matches ? matches[1] : null
  const idContent = data?.data?.attributes?.headerTabName || h2Content

  const getModifiedHtml = tableContent => {
    const $ = cheerio?.load(tableContent, null, false)

    $('p').each((_index, element) => {
      const $p = $(element)
      if ($p.html().trim() === '&nbsp;') {
        $p.remove()
      }
    })

    $('a').each((_index, element) => {
      const $a = $(element)
      $a.attr('target', '_blank')
    })

    const modifiedHTML = $.html()
    return modifiedHTML
  }

  const heading = getHeadingDesc(accordianData.sectionHeading)
  const isHowToComp =
    heading.heading.toLowerCase().includes('steps') || heading.heading.toLowerCase().includes('how to')

  const { WrapperTag } = HTMLTagsForHowTo.accordion(isHowToComp)

  return (
    <ErrorBoundary data={data}>
      <div className={`${styles.accordionRootContainer} white`} id={convertToSlug(idContent)}>
        {/* Section heading/decription */}
        <div
          className={styles.sectionHeading}
          dangerouslySetInnerHTML={{ __html: getModifiedHtml(accordianData?.sectionHeading || '') }}
        />
        {hasTabs && (
          <TabComponent
            activeStyles={styles.active}
            inactiveStyles={styles.inactive}
            groupedSectionCardsMap={mappedValuesForTabs}
            sectionVariantForStyling="plainBackground"
          />
        )}

        <div className={accordionOuterClass}>
          <div className={accordionContainerClass}>
            <form>
              <WrapperTag className={styles.fieldset}>
                {accordianData?.accordionCards.map((item, index) => (
                  <AccordionItem key={index} item={item} index={index} type={type} isHowToComp={isHowToComp} />
                ))}
              </WrapperTag>
            </form>
          </div>

          <ImageComponent firstItem={accordianData?.accordionCards[0]} withImage={withImage} />
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default Accordion
